import type { Beer, FilterOptions } from '../types/Beer';

export const mockBeers: Beer[] = [
  {
    id: '1',
    name: 'Imperial IPA 355ml',
    brewery: 'Avenida 42',
    style: 'Double IPA',
    price: 19.9,
    originalPrice: 25.9,
    subscriberPrice: 14.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/imp_ipa_355.png?alt=media&token=47bf22d2-d6cd-4e8a-abc6-a2886f25f8d7',
    description:
      'Uma IPA com 100 IBUs e 7,5% de ABV, com notas de frutas tropicais e levemente amargas.',
    abv: 7.5,
    ibu: 100,
    volume: 355,
    inStock: true,
    featured: false,
  },
  {
    id: '2',
    name: 'Old British 355ml',
    brewery: 'Avenida 42',
    style: 'Bitter',
    price: 17.9,
    originalPrice: 20.9,
    subscriberPrice: 12.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/old_british_355.png?alt=media&token=e18abb6e-88fe-4d42-8b4f-e2ca7dee3268',
    description:
      'Cerveja belga escura, rica em sabores de frutas secas e especiarias.',
    abv: 5.2,
    ibu: 30,
    volume: 355,
    inStock: true,
    featured: false,
  },
  {
    id: '3',
    name: 'Flavor Craft Experience Saison Hop Garrafa 355ml',
    brewery: 'Flavor Craft',
    style: 'Saison',
    price: 21.9,
    originalPrice: 25.9,
    subscriberPrice: 16.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Fflavor-saison.jpg?alt=media&token=3',
    description: 'Saison refrescante com notas florais e cítricas.',
    abv: 6.5,
    ibu: 30,
    volume: 355,
    inStock: true,
    featured: true,
  },
  {
    id: '4',
    name: 'Cerveja Artesanal IPA Americana 500ml',
    brewery: 'Cervejaria Nacional',
    style: 'IPA',
    price: 18.9,
    subscriberPrice: 14.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Fipa-americana.jpg?alt=media&token=4',
    description:
      'IPA lupulada com intenso aroma cítrico e amargor equilibrado.',
    abv: 6.8,
    ibu: 60,
    volume: 500,
    inStock: true,
  },
  {
    id: '5',
    name: 'Pilsen Premium Lager 350ml',
    brewery: 'Cervejaria Premium',
    style: 'Pilsen',
    price: 12.9,
    subscriberPrice: 9.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Fpilsen-premium.jpg?alt=media&token=5',
    description: 'Pilsen clássica, refrescante e de fácil bebida.',
    abv: 4.5,
    ibu: 18,
    volume: 350,
    inStock: true,
  },
  {
    id: '6',
    name: 'Weissbier Bavária 500ml',
    brewery: 'Bavária Cervejaria',
    style: 'Weissbier',
    price: 16.9,
    subscriberPrice: 12.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Fweissbier.jpg?alt=media&token=6',
    description: 'Cerveja de trigo alemã com notas de banana e cravo.',
    abv: 5.2,
    ibu: 12,
    volume: 500,
    inStock: true,
  },
  {
    id: '7',
    name: 'Stout Imperial 355ml',
    brewery: 'Cervejaria Imperial',
    style: 'Stout',
    price: 24.9,
    subscriberPrice: 19.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Fstout-imperial.jpg?alt=media&token=7',
    description: 'Stout encorpada com notas de chocolate e café.',
    abv: 8.0,
    ibu: 40,
    volume: 355,
    inStock: true,
  },
  {
    id: '8',
    name: 'Witbier Belga 330ml',
    brewery: 'Cervejaria Belga',
    style: 'Witbier',
    price: 19.9,
    subscriberPrice: 15.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Fwitbier.jpg?alt=media&token=8',
    description: 'Cerveja branca belga com coentro e casca de laranja.',
    abv: 4.8,
    ibu: 15,
    volume: 330,
    inStock: false,
  },
  {
    id: '9',
    name: 'Red Ale Americana 473ml',
    brewery: 'American Craft',
    style: 'Red Ale',
    price: 22.9,
    subscriberPrice: 17.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Fred-ale.jpg?alt=media&token=9',
    description: 'Red Ale equilibrada com maltes caramelizados.',
    abv: 5.8,
    ibu: 35,
    volume: 473,
    inStock: true,
  },
  {
    id: '10',
    name: 'Porter Robusta 500ml',
    brewery: 'Cervejaria Robusta',
    style: 'Porter',
    price: 20.9,
    subscriberPrice: 16.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Fporter.jpg?alt=media&token=10',
    description: 'Porter tradicional com sabores tostados intensos.',
    abv: 6.2,
    ibu: 28,
    volume: 500,
    inStock: true,
  },
  {
    id: '11',
    name: 'Lager Premium 350ml',
    brewery: 'Cervejaria Premium',
    style: 'Lager',
    price: 14.9,
    subscriberPrice: 11.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Flager-premium.jpg?alt=media&token=11',
    description: 'Lager suave e refrescante para todas as ocasiões.',
    abv: 4.2,
    ibu: 16,
    volume: 350,
    inStock: true,
  },
  {
    id: '12',
    name: 'Pale Ale Tropical 355ml',
    brewery: 'Tropical Brewery',
    style: 'Pale Ale',
    price: 17.9,
    subscriberPrice: 13.9,
    image:
      'https://firebasestorage.googleapis.com/v0/b/clube-42-3baa5.firebasestorage.app/o/beers%2Fpale-ale.jpg?alt=media&token=12',
    description: 'Pale Ale com lúpulos tropicais e notas frutadas.',
    abv: 5.5,
    ibu: 42,
    volume: 355,
    inStock: true,
  },
];

export const filterOptions: FilterOptions = {
  breweries: [
    'Big Foot Brewery',
    'Flavor Craft',
    'Cervejaria Nacional',
    'Cervejaria Premium',
    'Bavária Cervejaria',
    'Cervejaria Imperial',
    'Cervejaria Belga',
    'American Craft',
    'Cervejaria Robusta',
    'Tropical Brewery',
  ],
  styles: [
    'Barley Wine',
    'Quadrupel',
    'Saison',
    'IPA',
    'Pilsen',
    'Weissbier',
    'Stout',
    'Witbier',
    'Red Ale',
    'Porter',
    'Lager',
    'Pale Ale',
  ],
  priceRange: {
    min: 0,
    max: 50,
  },
};
